import {createSvgIcon} from '../create-svg-icon';

export const SignalCellularConnectedNoInternet4BarIcon = createSvgIcon(
  <path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z" />
, 'SignalCellularConnectedNoInternet4BarOutlined');
